<template>
  <v-card class="item" :to="to" tile flat>
    <img class="d-block item-img" :src="files + img + ''" width="100%" />

    <div class="pa-4 item-caption">
      <div
        class="
          text-body-2 text-sm-body-1 text-md-h6
          font-weight-medium
          item-title
        "
      >
        {{ title }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
    },
    title: {
      type: String,
    },
    to: {
      type: String,
    },
  },
  data: () => ({
    productId: 0,
  }),
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 4 / 3;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
